

export const timestamp_to_date = (timestamp: number | string | Date) => {
  if (!timestamp) {
    throw new Error("Invalid timestamp");
  }

  // If it's already a Date object, return it
  if (timestamp instanceof Date) {
    return timestamp;
  }

  // If it's already a number, treat as seconds (unix timestamp)
  if (typeof timestamp === 'number') {
    return new Date(timestamp * 1000);
  }

  // If it's a string
  if (typeof timestamp === 'string') {
    // Try parsing as a number first (e.g. "1700000000")
    const numericTimestamp = Number(timestamp);
    if (!isNaN(numericTimestamp)) {
      return new Date(numericTimestamp * 1000);
    }

    // Try parsing as a date string (ISO 8601, etc.)
    const date = new Date(timestamp);
    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  throw new Error("Invalid timestamp");
}